export class ConfigButton {
    constructor(
        public text: string,
        public onClick: () => Promise<any>,
        public className?: string,
        public icon?: string,
        public disableIfEmpty: boolean = false,
        public disabled: boolean = false,
        public menuItems?: ConfigButton[],
    ) {
    }

    /**
     * Constructs an array of ConfigButton objects from the provided button configurations.
     *
     * @param {...Object} buttons - A list of button configuration objects.
     * @param {string} buttons[].text - The text to display on the button.
     * @param {function} buttons[].onClick - An asynchronous function to execute when the button is clicked.
     * @param {string} [buttons[].className] - An optional CSS class name to apply to the button.
     * @param {string} [buttons[].icon] - An optional PrimeIcons class (e.g. "pi pi-plus") to display on the button.
     * @param {boolean} [buttons[].disabled] - An optional value to disable the button.
     * @return {ConfigButton[]} An array of ConfigButton instances built from the configuration objects.
     */
    static build(...buttons: { text: string, onClick: () => Promise<any>, className?: string, icon?:string, disableIfEmpty?: boolean}[]): ConfigButton[] {
        return buttons.map(item => new ConfigButton(item.text, item.onClick, item.className, item.icon, item.disableIfEmpty));
    }
}
